import $http from '@/resource';
import utils from '@/utils';
import input from './input';


const $api = Object.assign({}, input);

/**
 * 获取搜索备选项缓存
 *
 * @param {string} uid 用户uid
 * @param {string} cate 项目类型 1：土地，2：厂房，3：商业，4：写字楼，5：注册，6：客户，7：仓库，10：其他
 *
 * @date 2018-12-11 10:07:08
 *
 * @returns {Promise<any>}
 */
$api.getDefaultCarrierSearchData = (uid,cate="")=>{
    const url=`user/${uid}/carrier-search-cache?cate=${cate}`;
    const promise = new Promise(function(resolve){
        $http.get(url).then(function (response) {
            resolve(response);
        });
    });
    return promise;
};

/**
 * 用来拼接载体搜索的搜索条件
 *
 * @param {object} params 搜索项数组
 *
 * @date 2018-12-11 10:34:48
 *
 * @returns {string}
 */
$api.getCarrierSearchQuery = (params)=>{
    let query = "";
    for(let i in params){
        if(i === 'orderWord'){
            if(Array.isArray(params[i]) === true){
                query += `&orderWord=${params[i][0]}_${params[i][1]}`;
            }else{
                //针对排序条件做obj->string
                if(Object.keys(params[i]).length > 0){
                    for(let k in params[i]){
                        query += "&orderWord="+k+"_"+params[i][k];
                    }
                }
            }

        }else if(i === "totalprogress"){
            if(params[i].length > 0){
                query += "&totalprogress="+((typeof params[i] !== "string") ? params[i].join(',') : params[i]);
            }
        }else if(i === "totalstatus"){
            if(params[i].length > 0){
                query += "&totalstatus="+((typeof params[i] !== "string") ? params[i].join(',') : params[i]);
            }
        }else if(i === "dataRanger"){
            if(!(params[i][0]==='' && params[i][1]==='') && params[i].length > 0){
                query += "&dataRanger=" + params[i].join("~");
            }
        }else if(i === "nexttime"){
            if(!(params[i][0]==='' && params[i][1]==='') && params[i].length > 0) {
                query += "&nexttime=" + params[i].join("~");
            }
        }else if(i === "cloudtime"){
            if(!(params[i][0]==='' && params[i][1]==='') && params[i].length > 0) {
                query += "&cloudtime=" + params[i].join("~");
            }
        }else{
            query += `&${i}=${params[i]}`;
        }
    };

    query = query.substr(1);
    return query;
};

/**
 * 获取载体列表
 *
 * @param {object} params 搜索条件数据
 *
 * @date 2018-12-11 10:33:09
 *
 * @returns {Promise<any>}
 */
$api.getCarrierList = (params)=>{
    // console.log(params);
    let query = $api.getCarrierSearchQuery(params);
    const url = `carriers?${query}`;
    const promise = new Promise(resolve=>{
        $http.get(url).then(response=>{
            resolve(response);
        });
    });
    return promise;
};

/**
 * 获取载体列表导出excel的url
 *
 * @param {object} params 搜索项
 *
 * @date 2018-12-11 10:48:37
 *
 * @returns {string}
 */
$api.getCarrierDownloadListUrl = (params)=>{
    let query = $api.getCarrierSearchQuery(params);
    let url = `carrier/exporting`;
    if(query && query !== ""){
        url += `?${query}`;
    }
    return url;
};

/**
 * 删除载体
 *
 * @param {String} index_id 待删除载体的index_id
 *
 * @date 2018-12-13 10:59:04
 *
 * @return {Promise}
 */
$api.deleteCarrier = (index_id)=>{
    if(!index_id){
        return false;
    }
    const url = `carrier/${index_id}`;

    const promise = new Promise(resolve=>{
        $http.delete(url).then(response=>{
            resolve(response);
        });
    });
    return promise;
};

/**
 * 移动项目|修改项目类型
 *
 * @param {string} carrierIndexId 载体index_id
 * @param {string} cate 要移动至的分类
 *
 * @date 2018-12-13 14:37:54
 *
 * @returns {promise}
 */
$api.setCarrierCate = (carrierIndexId="", cate="")=>{
    if(!carrierIndexId || !cate){
        return false;
    }
    const url = `carrier/${carrierIndexId}/carrier-move`;
    const promise = new Promise((resolve)=>{
        $http.put(url,{"cate":cate}).then( (response)=>{
            resolve(response);
        });
    });
    return promise;
};

/**
 * 获取载体详情基本数据
 *
 * @param {string} indexId 载体index_id
 *
 * @date 2018-12-13 19:53:50
 *
 * @returns {Promise<any>}
 */
$api.getCarrierDetail = (indexId) => {
    const url = `carrier/${indexId}/detail`;
    const promise = new Promise((resolve)=>{
        $http.get(url).then( (response)=>{
            resolve(response);
        });
    });
    return promise;
};

/**
 * 获取载体标签
 *
 * @param {number} indexId 载体index_id
 *
 * @date 2018-12-17 11:28:36
 *
 * @return {Promise}
 */
$api.getCarrierTags = (indexId="")=>{
    if(!indexId){
        return false;
    }

    const url = `carrier/${indexId}/tags`;
    const promise = new Promise((resolve)=>{
        $http.get(url).then( (response)=>{
            resolve(response);
        });
    });
    return promise;
};

/**
 * 删除载体标签
 *
 * @param {number} indexId 载体index_id
 * @param {number} tagId 标签id
 *
 * @date 2018-12-17 11:28:36
 *
 * @return {Promise}
 */
$api.deleteCarrierTag = (indexId,tagId)=>{
    if(!indexId||!tagId){
        return false;
    }
    const url = `carrier/${indexId}/tags?tagid=${tagId}`;

    const promise = new Promise((resolve)=>{
        $http.delete(url).then( (response)=>{
            resolve(response);
        });
    });
    return promise;
};

/**
 * 添加载体标签
 *
 * @param {number} indexId 载体index_id
 * @param {number} tagId 标签id
 *
 * @date 2018-12-17 11:39:02
 *
 * @returns {Promise<any>}
 */
$api.addCarrierTag = (indexId,tagId)=>{
    const url = `carrier/${indexId}/tags`;
    const promise = new Promise((resolve)=>{
        $http.post(url,{"tagid":tagId}).then( (response)=>{
            resolve(response);
        });
    });
    return promise;
};

/**
 * 批量回收|还原载体
 *
 * @author zyz 2020-7-10 11:49:37
 *
 * @method put
 *
 * @param {Array} ids 待操作的项目id数组
 * @param {String} status 操作状态3-回收0-还原
 *
 * @url carrier/batch-recycle
 *
 * @return {Promise<void>}
 */
$api.batchRecycleCarrier = async(ids,status)=>{
    const url = "carrier/batch-recycle";
    return await $http.put(url,{'ids':ids,'status':status});
};

export default $api;


// WEBPACK FOOTER //
// ./src/service/carrier/index.js